import { queryOptions } from '@tanstack/react-query';
import { ApiError } from '~/components/Providers/APIClient';
import { apiQueryFn } from '../utils';
import { Bounty, BountyCompletion } from '~/util/types/bounties';

export const bountiesQuery = ({ list }: { list: 'classic' | 'platformer' }) =>
    queryOptions<Bounty[], ApiError>({
        queryKey: ['bounties', list],
        queryFn: apiQueryFn<Bounty[]>({
            path: `/${list === 'classic' ? 'aredl' : 'arepl'}/bounty-board`,
            attachAuth: true,
        }),
    });

export const bountyCompletionsQuery = ({
    list,
    bountyId,
}: {
    list: 'classic' | 'platformer';
    bountyId: string;
}) =>
    queryOptions<BountyCompletion[], ApiError>({
        queryKey: ['bounties', 'completions', list, bountyId],
        queryFn: apiQueryFn<BountyCompletion[]>({
            path: `/${list === 'classic' ? 'aredl' : 'arepl'}/bounty-board/${bountyId}/completions`,
            attachAuth: true,
        }),
    });
